import { useFlag } from "../../../server/optimizely";

/**
 * Whether the program tree pages replace the original programs pages, for the cha_4265_programs_2026
 * flag. loaded is false until the flag has loaded.
 */
export const usePrograms2026 = (): { enabled: boolean; loaded: boolean } => {
  const [enabled, , loaded] = useFlag("cha_4265_programs_2026");

  return { enabled: loaded && enabled, loaded };
};
